export default __webpack_public_path__ + "static/location-map-1f96bac0b7b9135d01d0e261ba8c6f82.jpg";